import { useDispatch, useSelector } from 'react-redux'
import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
const colorTextAction = 'var(--colorTextAction, var(--coreColorBlue600))'
const fontWeightBold = 'var(--fontWeightBold, 700)'

import { currentUserLocaleSelector } from 'selectors/user'
import { timezoneSelector } from 'selectors'
import { inviteeTimezoneSelector } from 'selectors/current_invitee'
import { isPublisherAndReschedulingSelector } from 'selectors/timezone'
import { changeTimezone } from 'actions/timezone'
import { useProfile } from 'components/use_profile'
import { useI18n } from 'locales'
import _Switch from "timezone_switch-Switch.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/timezone_switch.js?styleId=Switch";


const Switch = /*#__PURE__*/styled(BareButton, null, {
  displayName: "Switch",
  styles: _Switch
})

const TimezoneSwitch = () => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const currentTimezone = useSelector(timezoneSelector)
  const inviteeTimezone = useSelector(inviteeTimezoneSelector)
  const locale = useSelector(currentUserLocaleSelector)
  const isPublisherAndRescheduling = useSelector(isPublisherAndReschedulingSelector)
  const profile = useProfile()

  if (!profile) return null

  const profileTimezone = profile.timezone
  const canToggleTimezone = isPublisherAndRescheduling && profileTimezone !== inviteeTimezone

  if (!canToggleTimezone) return null

  const toggleTimezone = () => {
    if (currentTimezone === profileTimezone) {
      dispatch(changeTimezone(inviteeTimezone))
    } else {
      dispatch(changeTimezone(profileTimezone))
    }
  }

  const label = inviteeTimezone === currentTimezone
    ? i18n.t('publisher.reschedule.switch_to_publisher_timezone', { locale })
    : i18n.t('publisher.reschedule.switch_to_invitee_timezone', { locale })

  return (
    <Switch onClick={toggleTimezone}>
      {label}
    </Switch>
  )
}

export default TimezoneSwitch
